import ListViewRsvpUnitWrapper from 'mini-mail-list-rsvp-view/lib/components/ListViewRsvpUnitWrapper';
import React, { RefObject } from 'react';
import { getRsvpUnitAriaDetailsForMailListRow } from 'mini-mail-list-store/lib/selectors/mailListDataPropertyGetter';
import { MailListItemContainerProps } from 'mini-mail-list-view/lib/schema/MailListItemContainer.types';
import { RichContents } from 'mini-mail-list-item/lib/schema/RichContents';

export interface GetRichContentsProps extends MailListItemContainerProps {
    listViewItemRenderTime?: RefObject<number>;
}

export const getRichContents = (props: GetRichContentsProps): RichContents => {
    const { rowId, appliedRichContentFlags = { showRSVPUnit: false } } = props;
    const { showRSVPUnit = false } = appliedRichContentFlags;
    const richContents: RichContents = {
        RSVPUnit: {
            Component: showRSVPUnit ? <ListViewRsvpUnitWrapper mailListRowId={rowId} /> : null,
            ariaDetails: getRsvpUnitAriaDetailsForMailListRow(rowId),
        },
    };
    return richContents;
};
